<div id="group-management-component" class="component-inner-wrapper device-configuration-list-component-class">
  <main class="main-content">
    <div class="container">
      <div class="breadcrumb">
        <span class="ele_link" [routerLink]="['/user-management/customers']"
          >USER MANAGEMENT</span
        >
        <span>></span>
        <span>Group Management</span>
      </div>

      <div class="aggrid-criteria">
        <div class="grid-filter-criteria group-mgmt-filter-row">
          <div class="group-mgmt-title">
            <h1 class="page-title">Group Management</h1>
          </div>
          <div class="customer-filter">
            <label class="col-form-label me-2">Customer</label>
            <select
              class="custom-dropdown"
              [(ngModel)]="selectedCustomer"
              (change)="onHeaderCustomerChange($event)"
            >
              <option value="All">{{ customerDropdownSelectLabel }}</option>
              <option *ngFor="let item of customerList" [value]="item.customerName">
                {{ item.customerName }}
              </option>
            </select>
          </div>
          <div class="group-filter">
            <label class="col-form-label me-2">Group</label>
            <select
              class="custom-dropdown"
              [(ngModel)]="selectedGroup"
              (change)="onHeaderGroupChange($event)"
              [disabled]="isGroupDropdownDisabled"
              name="group"
            >
              <option value="">{{ groupDropdownEmptyLabel }}</option>
              <option *ngFor="let group of groups" [value]="group.groupName">
                {{ group.groupName }}
              </option>
            </select>
          </div>
        </div>
        <div class="add-group-btn-wrapper">
          <button
            type="button"
            class="btn-confirm"
            *appHasPermission="RbacPermissions.UserMgmt_Group_Add"
            (click)="onAddGroup()"
          >
            + Add Group
          </button>
        </div>
      </div>

      <div class="content-wrapper content-wrapper-aggrid">
        <div
          (contextmenu)="preventDefaultContextMenu($event)"
          mcAgGridCopyCellTooltip
          class="component-ag-grid-wrapper group-management-grid-shell"
          [style.--mc-ag-page-size]="paginationPageSize"
          [style.--mc-ag-host-height.px]="gridHostHeightPx"
          style="position: relative"
        >
          <div *ngIf="isLoading" class="refreshing-data" style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.8); z-index: 10;">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          <ag-grid-angular
            class="ag-theme-alpine"
            style="width: 100%;"
            [rowModelType]="'infinite'"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="pageSizeOptions"
            [cacheBlockSize]="paginationPageSize"
            [maxBlocksInCache]="1"
            [maxConcurrentDatasourceRequests]="1"
            [datasource]="dataSource"
            (gridReady)="onGridReady($event)"
            (paginationChanged)="onPaginationChanged($event)"
            (filterChanged)="onGridFilterChanged()"
            (cellContextMenu)="onCellContextMenu($event)"
          >
          </ag-grid-angular>
          <div class="custom-context-menu"
              [ngStyle]="{'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x}"
              *ngIf="contextMenuVisible">
              <ul>
                  <li (click)="handleCopy()">Copy Value</li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
